module.exports = __webpack_public_path__ + "img/bronze.f029653c.svg";